import { BreadcrumbItem } from 'components/breadcrumb/breadcrumbModel';
import { AttributeCode } from 'services/model/model.service';
import { useIntl } from 'react-intl';
import { TranslatedAttributeLabel } from 'pages/trading/TranslatedAttributeLabel';

export interface DetailPageBreadcrumbProps {
  breadcrumbItem: BreadcrumbItem;
  includeDate?: boolean;
}

export function AttributeDrilldownBreadcrumb({ breadcrumbItem, includeDate = false }: DetailPageBreadcrumbProps) {
  const intl = useIntl();

  const filters = breadcrumbItem.filters ?? [];

  const attributeCodeAndMessageId = breadcrumbItem.path.split('/').slice(-2);
  const attributeCode =
    attributeCodeAndMessageId.length > 0 ? (attributeCodeAndMessageId[0] as AttributeCode) : undefined;
  const attributeKey = decodeURIComponent(filters.find(f => f.attribute === attributeCode)?.values[0] as string);

  const dateRange = filters.find(f => f.attribute === 'dateRange');

  const fromDateString = dateRange
    ? (filters.find(f => f.attribute === 'dateRange')?.values[0] as unknown as { from: string }).from
    : undefined;

  return (
    <div>
      <TranslatedAttributeLabel attributeCode={attributeCode ?? ''} attributeValue={attributeKey ?? ''} />
      {includeDate && fromDateString && (
        <span>&nbsp;- {intl.formatDate(new Date(fromDateString), { dateStyle: 'short' })}</span>
      )}
    </div>
  );
}
